export const sumByField = (arr, field) => {
	return arr.reduce((acc, curr) => acc + curr[field], 0);
};
